module.exports = __webpack_public_path__ + "img/symbol_7.9ace1658.png";